import React from "react";
import SideNavLayout from "src/components/layouts/SideNavLayout/SideNavLayout";
import OfflineOrderForm from "../Layouts/OfflineOrderForm";
import { OfflineOrderFormValues } from "src/models/OfflineOrder.model";
import { Form, Formik, FormikHelpers } from "formik";
import { array, number, object, string } from "yup";
import { showToast } from "src/utils/showToaster";
import { useAddOfflineOrderMutation } from "src/services/OfflineOrderService";
import { useNavigate } from "react-router-dom";
import useDrawer from "src/hooks/useDrawer";
import usePaymentModes from "src/hooks/usePaymentModes";
import useCourseType from "src/hooks/useCourseType";

const AddOfflineOrderWrapper = () => {
  const [addOfflineOrder] = useAddOfflineOrderMutation();
  const { drawer, isDataLoading } = useDrawer();
  const { paymentMode, isDataLoading: isModeLoading } = usePaymentModes();
  const getPaymentModes = (type: "PHYSICAL" | "VIRTUAL") => {
    return (
      paymentMode
        ?.filter((pm: any) => pm?.type === type)
        .map((pm: any) => ({
          label: pm?.name,
          value: pm?.value,
          type: pm?.type,
        })) || []
    );
  };

  const virtualPaymentModes = getPaymentModes("VIRTUAL");

  const physicalModes =
    drawer?.filter((mode: any) => mode?.type === "PHYSICAL") || [];
  const navigate = useNavigate();
  const initialValues: OfflineOrderFormValues = {
    name: "",
    image: "",
    email: "",
    mobile: "",
    duedate: "",
    croNumber: "",
    userType: { label: "Student", value: "STUDENT" },
    courseType: "",
    deliveryOption: "",
    discount: "0",
    discountType: { label: "None", value: "NONE" },
    courierCharges: "",
    // key: "",
    products: [
      {
        productId: "",
        quantity: "",
        variantId: "",
      },
    ],
    // level: "",
    // faculty: "",
    // subject: "",
    totalFees: "",
    orderTotal: "",
    // orderId: "",
    totalAdvancePayment: "",
    amountPaid: "",
    bookIssued: [],
    remark: "",
    // mode: "",
    // franchiseId: "",
    receivedAmt: "",
    remainingFees: "",
    advanceAmount: "",
    paymentMode: physicalModes?.map((mode: any) => ({
      name: mode.name,
      value: mode.value,
      quantity: "",
      type: mode.type,
    })),
    address: "",
    city: "",
    state: "",
    pincode: "",
    isSelected: false,
    adjustAgainstMobile: "",
  };
  
  // Validation Schema
  const validationSchema = object().shape({
    name: string().required("Please enter name"),
    mobile: string().required("Please enter mobile number"),
    email: string()
    .email("Please enter valid email")
    .required("Please enter email"),
    address: string().test(
      "address-test",
      "Address required",
      (value, context) => {
        const { deliveryOption } = context.parent;
        
        // const pervious = perviousMembershipPrice;
        if (deliveryOption?.value === "HOME_DELIVERY" && !value) {
          return false;
        }
        return true;
      }
    ),
    city: string().test(
      "address-test",
      "City is required",
      (value, context) => {
        const { deliveryOption } = context.parent;

        // const pervious = perviousMembershipPrice;
        if (deliveryOption?.value === "HOME_DELIVERY" && !value) {
          return false;
        }
        return true;
      }
    ),
   remainingFees: number().required("Remaining Fees is required"),
duedate: string().test(
  "duedate-test",
  "Due date is required when remaining fees > 0",
  function(value) {
    const remainingFees = Number(this.parent.remainingFees) || 0;
    if (remainingFees > 0) {
      return Boolean(value && String(value).trim() !== "" && value !== "Invalid date");
    }
    return true;
  }
),
    state: string().test(
      "address-test",
      "State is required",
      (value, context) => {
        const { deliveryOption } = context.parent;
        // const pervious = perviousMembershipPrice;
        if (deliveryOption?.value === "HOME_DELIVERY" && !value) {
          return false;
        }
        return true;
      }
    ),
    pincode: string().test(
      "address-test",
      "Pincode is required",
      (value, context) => {
        const { deliveryOption } = context.parent;

        // const pervious = perviousMembershipPrice;
        if (deliveryOption?.value === "HOME_DELIVERY" && !value) {
          return false;
        }
        return true;
      }
    ),

    // croNumber: string().required("Please enter CRO number"),
    // courseType: object().required("Please select course type"),
    deliveryOption: object().required("Please select one delivery option"),
    // course: object().required("Please select course"),
    // level: object().required("Please select level"),
    // faculty: array().required("Please select at least one faculty"),
    // subject: array().required("Please select at least one subject"),
    // totalFees: string().required("Please enter total fees"),
    //  paymentMode: array().of(
    //        object().shape({
    //          name: string().required("Please enter name"),
    //          value: number().required("Please enter value"),
    //        })
    //      ),
    //   advanceAmount: string().test(
    //     "address-test",
    //     "amount is not  more then the total Fees and advance amount",
    //     (value: any, context) => {
    //       const { totalFees } = context.parent;
    //       const { totalAdvancePayment } = context.parent;

    //       // const pervious = perviousMembershipPrice;
    //       if (totalFees < value || totalAdvancePayment < value) {
    //         return false;
    //       }
    //       return true;
    //     }
    //   ),

    // duedate: string().when("remainingFees", {
    //   is: (remainingFees: any) => remainingFees > 0,
    //   then: (schema) =>
    //     schema.required("Due Date is required when remaining fees > 0"),
    //   otherwise: (schema) => schema.nullable(),
    // }),
    //   bookIssued: array().of(
    //     object({
    //       BookName: string().required("Please enter book name "),
    //     })
    //   ),
    // mode: object().required("Please select mode"),
  });
  const formatFormData = (values: OfflineOrderFormValues) => {
    // Transform products
    const products = values.products
      .filter((product) => product.productId) // Only include products with IDs
      .map((product) => ({
        productId: product.productId,
        variantId: product.variantId,
        quantity: Number(product.quantity) || 0,
      }));

    // Transform bookIssued into a flat array of book IDs
    const bookIssued = values.bookIssued.flatMap(
      (issue) => issue.bookIssued || []
    );

    // Transform payment modes
    const paymentMode = values.paymentMode
      .filter((mode: any) => mode.amount > 0) // Only include modes with amount
      .map((mode) => ({
        name: mode.name,
        value: Number(mode.value),
        quantity: Number(mode.quantity) || 1,
        type: mode.type,
      }));

    return {
      userType: values.userType?.value || "STUDENT",
      name: values.name,
      email: values.email,
      adjustAgainstMobile: values.adjustAgainstMobile
        ? values.adjustAgainstMobile
        : values?.mobile,
      mobile: values.mobile,
      delivery: values.deliveryOption?.value || "",
      address: values.address || "",
      state: values.state || "",
      duedate:
        values.duedate && values.duedate !== "Invalid date"
          ? values.duedate
          : "",
      city: values.city || "",
      pincode: values.pincode || "",
      image: values.image || "",
      croNumber: values.croNumber || "",
      remark: values.remark || "",
      products: values.bookIssued.map((item: any) => ({
        productId: item.productId,
        variantId: item.variantId,
        quantity: item.quantity,
        price: Number(item.price) || 0,
      })),
      bookIssued: values.bookIssued.flatMap((item: any) =>
        (item.bookIssued || []).map((bookId: any) => ({
          bookId: bookId?.bookId,
          isIssued: bookId?.isIssued,
        }))
      ),
      orderTotal: Number(values.orderTotal) || 0,
      discountType: values.discountType?.value || "",
      discountValue: values.discount
        ? `${values.discount}${
            values.discountType?.value === "PERCENTAGE" ? "%" : ""
          }`
        : "",
      courierCharges: Number(values.courierCharges) || 0,
      receivedAmt: Number(values.receivedAmt) || 0,
      paymentMode: values.paymentMode
        .filter((mode) => mode.quantity && mode.quantity !== "")
        .map((mode) => ({
          name: mode.name,
          value: Number(mode.value),
          quantity: Number(mode.quantity),
          type: mode.type,
        })),
      // Only include these if they exist
      ...(values.adjustAgainstMobile && {
        adjustAgainstMobile: values.adjustAgainstMobile,
      }),
      ...(values.advanceAmount && {
        advanceAmount: Number(values.advanceAmount),
      }),
    };
  };
  // Handle Submit
  const handleSubmit = (
    values: OfflineOrderFormValues,
    { setSubmitting, resetForm, setStatus }: FormikHelpers<OfflineOrderFormValues>
  ) => {
   
    const totalModeAmount = values.paymentMode.reduce((acc, curr) => {
      return acc + (curr.quantity || 0) * (curr.value || 0);
    }, 0);
    const totalAmount = values?.receivedAmt ? Number(values?.receivedAmt) : 0;
    if (totalModeAmount !== totalAmount) {
      showToast(
        "error",
        "Total recived amount and note total Amount must be equal."
      );
      setStatus({ step: 2 });
      setSubmitting(false);
      return;
    }
    const formattedData = formatFormData(values);

    addOfflineOrder(formattedData).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          navigate("/offline-order");
          resetForm();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  // if (isModeLoading && isDataLoading) {
  //   return <div>...Loading</div>;
  // }

  return (
    <>
      <SideNavLayout>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {(formikProps) => (
            <Form>
              <OfflineOrderForm
                onlineMode={virtualPaymentModes}
                physicalModes={physicalModes}
                formikProps={formikProps}
              />
            </Form>
          )}
        </Formik>
      </SideNavLayout>
    </>
  );
};

export default AddOfflineOrderWrapper;
